module.exports = __webpack_public_path__ + "static/media/_DTT.363bd3cc.svg";